/*
 * Angular bootstraping
 */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { decorateModuleRef } from './platform/environment';
import { enableProdMode } from '@angular/core';
import LogRocket from 'logrocket';
import { whichEnv } from './app/shared/helpers/whichEnv';

import { BlockedLogRocketRoutes } from './app/shared/models/Enum/BlockedLogRocketRoutes';
const scrubbedRoutes = ['auth/anonymous_invoke', 'handshake', 'submit', 'idmcreateuser'];

function isJson(value) {
  try {
    return !!value && JSON.parse(value);
  } catch (e) {
    return false;
  }
}

enableProdMode();
if (!whichEnv.isDevLike) {
  fetch('/ola/api/handshake/getLogRocketInstance')
    .then((response) => response.text())
    .then((key) =>
      LogRocket.init(key, {
        shouldCaptureIP: false,
        rootHostname: 'ally.com',
        network: {
          responseSanitizer: (response) => {
            const url = response.url ? response.url.toLowerCase() : '';
            for (let i = 0; i < scrubbedRoutes.length; i++) {
              if (url && url.toLowerCase().includes(scrubbedRoutes[i].toLowerCase())) {
                delete response.body; // eslint-disable-line no-param-reassign
                break;
              }
            }
            return response;
          },
          requestSanitizer: (request) => {
            const req = request.url.toLowerCase();
            if (request.body) {
              const body = isJson(request.body);

              if (body) {
                if (body.accessToken) {
                  body.accessToken = 'XXXXXXXX';
                }
                request.body = JSON.stringify(body); // eslint-disable-line no-param-reassign
              }
            }

            if (!BlockedLogRocketRoutes.some((route) => req.includes(route))) { // if route is not blocked
              // if url is a scrubbed route, delete request headers and request body
              for (let i = 0; i < scrubbedRoutes.length; i++) {
                // to check in case route is not a proper, but not exact, match
                if (req && req.toLowerCase().includes(scrubbedRoutes[i].toLowerCase())) {
                  if (request.body) {
                    delete request.body; // eslint-disable-line no-param-reassign
                  }
                  if (request.headers) {
                    delete request.headers; // eslint-disable-line no-param-reassign
                  }
                  break;
                }
              }
              // log the request normally if not a blocked route
              return request;
            }
            return false;
          },
        },
      })
  );
}

/*
 * App Module
 * our top level module that holds all of our components
 */
import { RootModule } from './app/components/root/root.module';


/**
 * Bootstrap our Angular app with a top level component `App` and inject
 * our Services and Providers.
 *
 * @returns {Promise}
 */
export function main() {
  return platformBrowserDynamic()
    .bootstrapModule(RootModule, { preserveWhitespaces: true })
    .then(decorateModuleRef)
    .catch((err) => console.error(err));
}

document.addEventListener('DOMContentLoaded', main);
